import { render, staticRenderFns } from "./LifeContainer.vue?vue&type=template&id=7551fc2e"
import script from "./LifeContainer.vue?vue&type=script&lang=ts"
export * from "./LifeContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports